import React, {Component, ReactElement} from 'react';
import Table, {TableColumn} from "../Table";
import IMisFetchHost from "../../models/hosted-salamander/IMisFetchHost";
import {TableRowProps} from "../TableRow";
import TableCell from "../TableCell";

interface MisFetchHostTableProps {
    title: string;
    hosts?: IMisFetchHost[];
    emptyMessage?: string;
    highlightCurrentRunId?: boolean;
    linkForHost?: (host: IMisFetchHost) => string | undefined;
}

interface MisFetchHostTableState {
}

const HOST_COLUMNS: TableColumn[] = [
    {
        title: "Tenant Id",
        propertyPath: "tenantId",
        flex: 1,
        enableSort: true
    },
    {
        title: "School code",
        propertyPath: "schoolCode",
        flex: 1,
        enableSort: true
    },
    {
        title: "Current Run Id",
        propertyPath: "currentRunId",
        flex: 1,
        enableSort: false
    },
    {
        title: "State",
        propertyPath: "state",
        flex: 1,
        enableSort: true
    },
    {
        title: "Metadata",
        propertyPath: "metadata",
        flex: 1,
        enableSort: false
    }
];

export default class MisFetchHostTable extends Component<MisFetchHostTableProps, MisFetchHostTableState> {
    static displayName = MisFetchHostTable.name;

    constructor(props: MisFetchHostTableProps) {
        super(props);

        this.state = {
        }
    }

    private cellForColumn = (item: IMisFetchHost, column: TableColumn, columnIndex: number): ReactElement<TableCell> | undefined => {
        
        if(this.props.highlightCurrentRunId === true && column.propertyPath === "currentRunId")
        {
            return (
                <TableCell key={columnIndex} flex={column.flex}>
                    <div className={"pill pill--blue pill--width-fit-content"}>{item.currentRunId}</div>
                </TableCell>
            );
        }
        
        return undefined;
    }
    
    render() {
        
        return (
            <Table
                title={this.props.title}
                columns={HOST_COLUMNS}
                items={this.props.hosts!}
                loading={this.props.hosts === undefined}
                emptyMessage={this.props.emptyMessage}
                cellForColumn={this.cellForColumn}
                rowPropsForItem={(host: IMisFetchHost) => {
                    const linkUrl = this.props.linkForHost ? this.props.linkForHost(host) : undefined;
                    return {
                        enableRowLink: linkUrl !== undefined,
                        to: linkUrl
                    } as TableRowProps;
                }}
            >
                {this.props.children}
            </Table>
        );
    }
}
